var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F46524"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36719 25.5531V5.125H15.1781C16.6733 5.125 17.9493 5.40097 19.0063 5.9529C20.0696 6.49818 20.8784 7.27288 21.4327 8.27699C21.9934 9.27446 22.2737 10.4481 22.2737 11.798C22.2737 13.1546 21.9901 14.3216 21.423 15.2992C20.8559 16.27 20.0342 17.0148 18.9579 17.5335C17.8881 18.0522 16.5927 18.3115 15.0718 18.3115H9.84194V14.8403H14.3951C15.1942 14.8403 15.858 14.7273 16.3865 14.5012C16.915 14.2751 17.3081 13.9359 17.5659 13.4838C17.8301 13.0316 17.9622 12.4697 17.9622 11.798C17.9622 11.1198 17.8301 10.5479 17.5659 10.0824C17.3081 9.61692 16.9117 9.26448 16.3768 9.02509C15.8484 8.77905 15.1813 8.65603 14.3758 8.65603H11.553V25.5531H7.36719ZM18.0589 16.2567L22.9794 25.5531H18.3586L13.5444 16.2567H18.0589Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main-logo.70e87a1d833a16c95bfca76cc218533f.svg";
export { ForwardRef as ReactComponent };